import React, {Component} from 'react';

export default class OptionsElement extends Component{
	render(){
		const {label, price, valute, id, check, window_height, window_width, onChangeOptionCheckbox, currentTypeWindowId, typewindowdata} = this.props;

		const el_id = `sprofile-${id}`;
		let calcprice = 0;

		const WIDTH_DOOR = typewindowdata.widthDoor || 0;

		if (currentTypeWindowId === 5){
			switch (label.toLowerCase()){
				case 'монтаж':
					const
							HEIGHT_REST = typewindowdata.heightRest,
							area = window_width * window_height,
							areaDoor = WIDTH_DOOR * window_height,
							areaRest = HEIGHT_REST * (window_width - WIDTH_DOOR),
							areaWindow = area - areaDoor - areaRest;
							calcprice = Number((price * (areaWindow + areaDoor)  / 1000000).toFixed())
					break;
				case 'подоконник':
					calcprice = Number((price * window_width / 1000).toFixed());
					break;
				case 'отлив':
						calcprice = Number((price * (window_width - WIDTH_DOOR)  / 1000).toFixed());
					break;
				case 'откосы':
					calcprice = Number(((2 * window_height + window_width) / 1000 * price).toFixed());
					break;
				default:
					calcprice = price;
					break;
			}
		} else{
			switch (label.toLowerCase()){
				case 'монтаж':
					calcprice = Number((price * window_width * window_height / 1000000).toFixed());
					break;
				case 'подоконник':
					calcprice = Number((price * window_width / 1000).toFixed());
					break;
				case 'отлив':
						calcprice = (Number(price * window_width / 1000).toFixed());
					break;
				case 'откосы':
					calcprice = Number(((2 * window_height + window_width) / 1000 * price).toFixed());
					break;
				default:
					calcprice = price;
					break;
			}
		}



		return (
			<div className="checkbox">
				<input type="checkbox" name="wincalc-options" id={el_id}
					value={calcprice}
					onChange={(e) => onChangeOptionCheckbox(id)}
					checked={check}
				/>
				<label htmlFor={el_id}>
					<div className="option-wrapper">
						{label}
						<span className="option-price"><span>+{calcprice}</span> <span className="rub">{valute}</span></span>
					</div>
				</label>
			</div>
		)
	}
}